/**
 * 
 * 
 */

 import React from 'react';
 import { Trans } from "react-i18next";
 
 
 function Modal( props ) {
 
   const handleCloseClick = () => {
     props.onCloseClick();
     return false;
   }

   let modalClasses = 'app-modal';

   if( props.modalState == "closed" ){
    modalClasses = modalClasses + " closed";
   }

   if( props.modalState == "opened" ){
    modalClasses = modalClasses + " opened";
   }
   
   let modalTitle = "";

   if( typeof props.modalTitle !== "undefined" && props.modalTitle ){
    modalTitle = props.modalTitle;
   }
 
  return (
    <div className={modalClasses}>

      <div className="modal-heading">
        <a href="#/" className="btn dark btn-close" onClick={handleCloseClick}>
          <span className="close-icon-white"></span>
        </a>
      </div>

      <div className="modal-body">
        {( modalTitle !== "" ) && (
          <h2 className="heading">{modalTitle}</h2>
        )}
        {props.children}
      </div>


      <div className="app-fragment pull-bottom-fixed pull-bottom-gradient">
        <a href="#/" className="btn dark full-width mt-6" onClick={handleCloseClick}>
        <Trans>Close</Trans>
        </a>
      </div>
    </div>
  );
}

export default Modal;